<div class="insert-object-dialog-content">
    <div class="insert-object-header">
        <div class="logo-title">

            <h2 mat-dialog-title class="title">Insert Object</h2>
        </div>
        <button mat-icon-button (click)="onClose()" class="close-button">
            <mat-icon>close</mat-icon>
        </button>
    </div>

    <div mat-dialog-content class="insert-object-body">
        <div class="left-panel">
            <div class="search-bar">
                <mat-icon class="search-icon">search</mat-icon>
                <input type="text" placeholder="Search all objects..." [(ngModel)]="searchText"
                    (ngModelChange)="onSearchTextChange()">
            </div>

            <div class="own-projects-section">
                <h3>Own Projects</h3>
                <button mat-raised-button class="own-projects-button" (click)="loadOwnProjects()"
                    [class.active]="currentView === 'own' && !searchText">
                    <mat-icon>folder</mat-icon> Own Projects
                </button>
            </div>

            <div class="objects-section">
                <h3>Objects by Category</h3>
                <div [class.dimmed-tree]="searchText.length > 0">
                    <tree-root [nodes]="nodes" (activate)="onNodeActivate($event)"></tree-root>
                </div>
            </div>
        </div>

        <div class="center-panel">
            <div *ngIf="isLoadingProjects" class="loading-spinner-container">
                <mat-spinner diameter="50"></mat-spinner>
                <p>Loading objects...</p>
            </div>

            <div *ngIf="!isLoadingProjects && displayedProjects.length === 0">
                <div *ngIf="currentView === 'search'" class="no-projects-message">
                    No objects found matching your search "<strong>{{ searchText }}</strong>".
                </div>
                <div *ngIf="currentView === 'category' && currentCategoryId" class="no-projects-message">
                    No objects found for the selected category.
                </div>
                <div *ngIf="currentView === 'own'" class="no-projects-message">
                    You have no projects, or none match the filter if search was used previously.
                </div>
                <div *ngIf="currentView === 'none'" class="no-projects-message">
                    Select a category, click "Own Projects", or use the search bar.
                </div>
            </div>

            <div class="object-grid" *ngIf="!isLoadingProjects && displayedProjects.length > 0">
                <div *ngFor="let project of displayedProjects" class="object-item"
                    [class.selected]="project === selectedProjectDisplay" (click)="onProjectSelect(project)">
                    <img *ngIf="project.image" [src]="project.image" [alt]="project.name"
                        class="object-icon-placeholder">
                    <div *ngIf="!project.image" class="object-icon-placeholder"></div>
                    <span>{{ project.name }}</span>
                </div>
            </div>
        </div>

        <div class="right-panel">
            <div *ngIf="selectedProjectDisplay" class="project-details-container">
                <h3>{{ selectedProjectDisplay.name }}</h3>
                <img *ngIf="selectedProjectDisplay.image" [src]="selectedProjectDisplay.image"
                    [alt]="selectedProjectDisplay.name" class="project-detail-image">
                <div *ngIf="!selectedProjectDisplay.image" class="object-icon-placeholder project-detail-image"></div>
                <p><strong>ID:</strong> {{ selectedProjectDisplay.id }}</p>
                <p *ngIf="selectedProjectDisplay.description">{{ selectedProjectDisplay.description }}</p>
                <p *ngIf="!selectedProjectDisplay.description && selectedProjectDisplay"><em>No description
                        available.</em></p>
            </div>

            <div *ngIf="!selectedProjectDisplay">
                <h3>AI Suggestions</h3>
                <button mat-raised-button color="primary" class="ai-suggestion-button">Motor</button>
                <button mat-raised-button color="primary" class="ai-suggestion-button">Conveyor</button>
                <button mat-raised-button color="primary" class="ai-suggestion-button">Frame</button>
            </div>
        </div>
    </div>

    <div mat-dialog-actions class="insert-object-footer">
        <button mat-button (click)="onClose()">Cancel</button>
        <button mat-raised-button color="primary" (click)="addSelectedProjectToScene()"
            [disabled]="!selectedProjectDisplay">
            Add to Scene <mat-icon>arrow_forward</mat-icon>
        </button>
    </div>
</div>